export default "__VITE_ASSET__YMb5llfr__"